// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Skeleton-errorMessage-WYcAH {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.Skeleton-space1-sbAdJ {
	margin-bottom: 6px !important;
}
.Skeleton-space2-uJXc_ {
	margin-bottom: 12px !important;
}
.Skeleton-space3-JiJIJ {
	margin-bottom: 18px !important;
}
.Skeleton-space4-hhNGm {
	margin-bottom: 24px !important;
}
.Skeleton-space5-ehTNN {
	margin-bottom: 30px !important;
}
.Skeleton-space6-Rrr9V {
	margin-bottom: 36px !important;
}
.Skeleton-space7-gOlQI {
	margin-bottom: 42px !important;
}
.Skeleton-spaceTop8-AItb2 {
	margin-bottom: 48px !important;
}
.Skeleton-spaceTop1-sxFYH {
	margin-top: 6px !important;
}
.Skeleton-spaceTop2-j8IN7 {
	margin-top: 12px !important;
}
.Skeleton-spaceTop3-OplDJ {
	margin-top: 18px !important;
}
.Skeleton-spaceTop4-uHYM1 {
	margin-top: 24px !important;
}
.Skeleton-spaceTop5-dMXbw {
	margin-top: 30px !important;
}
.Skeleton-spaceTop6-XiWZb {
	margin-top: 36px !important;
}
.Skeleton-spaceTop7-S9Q6C {
	margin-top: 42px !important;
}
.Skeleton-spaceTop8-AItb2 {
	margin-top: 48px !important;
}
.Skeleton-noMargin-tJbx2 {
	margin: 0px !important;
}
.Skeleton-padding1-fhn99 {
	padding-bottom: 6px !important;
}
.Skeleton-padding2-VYl0Z {
	padding-bottom: 12px !important;
}
.Skeleton-padding3-x0X5E {
	padding-bottom: 18px !important;
}
.Skeleton-padding4-vsTIa {
	padding-bottom: 24px !important;
}
.Skeleton-padding5-xwieZ {
	padding-bottom: 30px !important;
}
.Skeleton-padding6-Igq7R {
	padding-bottom: 36px !important;
}
.Skeleton-padding7-ZZrwh {
	padding-bottom: 42px !important;
}
.Skeleton-paddingTop1-hg1De {
	padding-top: 6px !important;
}
.Skeleton-paddingTop2-GJE_N {
	padding-top: 12px !important;
}
.Skeleton-paddingTop3-edcnt {
	padding-top: 18px !important;
}
.Skeleton-paddingTop4-MCzvW {
	padding-top: 24px !important;
}
.Skeleton-paddingTop5-PUG9K {
	padding-top: 30px !important;
}
.Skeleton-paddingTop6-SNjtE {
	padding-top: 36px !important;
}
.Skeleton-paddingTop7-Fh4LY {
	padding-top: 42px !important;
}
.Skeleton-noPadding-AOyPq {
	padding: 0px !important;
}
.Skeleton-textBold-b3Oe4 {
	font-weight: 500 !important;
}
.Skeleton-textBolder-Nv1aC {
	font-weight: 700 !important;
}
.Skeleton-textNormal-UASON {
	font-weight: normal !important;
}
.Skeleton-spaceBottom20-aQaAY {
	margin-bottom: 20px;
}
.Skeleton-spaceBottom10-xI3CA {
	margin-bottom: 10px;
}
.Skeleton-marginNone-mE8Vu {
	margin: 0;
}
.Skeleton-spaceBottom15-jFype {
	margin-bottom: 15px;
}
.Skeleton-marginTopNone-_UMuY {
	margin-top: 0;
}
.Skeleton-spaceTop11-IIjPg {
	margin-top: 11px;
}
.Skeleton-spaceTop21-ypqXW {
	margin-top: 21px;
}
.Skeleton-spaceTop20-dmqLW {
	margin-top: 20px;
}
.Skeleton-spaceTop10-EN3O_ {
	margin-top: 10px;
}
/*New Design Text Colors */
.Skeleton-textDarkBlue-mt96o {
	color: rgb(20, 39, 94) !important;
}
.Skeleton-textLightBlue-chxvm {
	color: rgb(57, 87, 106) !important;
}
.Skeleton-textLightSandleGreen-qazYU {
	color: rgb(76, 86, 41) !important;
}
.Skeleton-textLightBrown-CAn48 {
	color: rgb(115, 79, 33) !important;
}
.Skeleton-textMediumMaroon-DqCnd {
	color: rgb(87, 37, 51) !important;
}
.Skeleton-textBrown-lKP0v {
	color: rgb(160, 47, 24) !important;
}
.Skeleton-textMaroon-bwj4u {
	color: rgb(155, 49, 67) !important;
}
.Skeleton-textDarkBrown-K2U0D {
	color: rgb(83, 18, 16) !important;
}
.Skeleton-textMediumBrown-2XcXO {
	color: rgb(142, 28, 10) !important;
}
.Skeleton-textSkyBlue-OUWXN {
	color: rgb(37, 117, 141) !important;
}
.Skeleton-textGray-EDlL_ {
	color: rgb(77, 65, 51) !important;
}
.Skeleton-btn-y5N8O,
.Skeleton-btn-y5N8O:focus {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 6px 12px !important;
	width: auto;
	outline: 0 !important;
	border: 1px solid var(--primary-border) !important;
	border-radius: 4px !important;
	background: var(--background-primary) !important;
	color: var(--primary-btn-foreground) !important;
}
.Skeleton-btn-y5N8O:hover {
	background: var(--primary-border) !important;
	outline: 0 !important;
}
.Skeleton-btnPrimary-v183z,
.Skeleton-btnPrimary-v183z:focus {
	border-color: var(--primary-bg) !important;
	background-color: var(--primary-bg) !important;
	color: var(--primary-btn-foreground) !important;
}
.Skeleton-btnPrimary-v183z:hover {
	border-color: var(--primary-bg-hover) !important;
	background-color: var(--primary-bg-hover) !important;
	color: var(--primary-btn-foreground) !important;
}
.Skeleton-btnPrimaryBorder-SjmVP,
.Skeleton-btnPrimaryBorder-SjmVP:focus {
	border-color: var(--primary-bg) !important;
	color: var(--primary-bg) !important;
	background-color: var(--background-primary) !important;
}
.Skeleton-btnPrimaryBorder-SjmVP:hover {
	border-color: var(--primary-bg-hover) !important;
	color: var(--primary-bg-hover) !important;
	background-color: var(--background-primary) !important;
}
.Skeleton-btnLink-j1Pg6,
.Skeleton-btnLink-j1Pg6:focus,
.Skeleton-btnLink-j1Pg6:hover {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 0px !important;
	width: auto !important;
	outline: 0 !important;
	background: transparent !important;
	color: var(--primary-link-foreground) !important;
	font-weight: inherit;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: inherit;
	border: 0px !important;
}
.Skeleton-searchFilterPopover-uqQCA {
	position: absolute;
	top: 51px;
	left: 0px;
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	display: inline-block;
	max-height: 65vh;
	visibility: visible;
	background: var(--background-primary);
	-webkit-box-shadow: 0px 0px 10px var(--primary-box-shadow);
	        box-shadow: 0px 0px 10px var(--primary-box-shadow);
	border-radius: 14px;
}
.Skeleton-searchFilterPopoverFull-l5hKj {
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	position: fixed;
	left: 0px;
	bottom: 0px;
	width: 66%;
	height: initial;
	-webkit-box-shadow: none;
	        box-shadow: none;
	visibility: visible;
	top: 148px;
	background-color: var(--modal-bg);
	border-radius: 4px;
	border-width: initial;
	border-style: none;
	border-color: initial;
	-o-border-image: initial;
	   border-image: initial;
}
.Skeleton-searchFilterPopoverOverlay-Asnv4 {
	position: fixed;
	height: 100vh;
	width: 100%;
	top: 64px;
	z-index: 2;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	background: rgba(255, 255, 255, 0.85);
	left: 0;
	right: 0;
	visibility: visible;
	bottom: 0;
	-webkit-overflow-scrolling: touch;
}
.Skeleton-dateFilterpopVerlayHeight-AtT_w {
	max-height: 100%;
}
.Skeleton-dateFilterpopVerlayContentHeight-FkT2B {
	min-height: 100% !important;
}
.Skeleton-searchFilterCloseIcon-Cdz54 {
	font-size: 30px;
	color: var(--secondary-foreground);
}
.Skeleton-searchFilterPopoverFooter-YvpWH {
	width: 100%;
	position: relative;
	line-height: 0;
}
.Skeleton-displayTable-XmGG1 {
	display: table;
	width: 100%;
	vertical-align: middle;
}
.Skeleton-displayTableRow-I5G0L {
	display: table-row;
	vertical-align: middle;
}
.Skeleton-displayTableCell-_y_0K {
	display: table-cell;
	vertical-align: middle;
}
.Skeleton-displayInlineBlock-ia3hu {
	display: inline-block;
	vertical-align: top;
	white-space: normal;
}
.Skeleton-fullWidth-gZ9cw {
	width: 100% !important;
}
.Skeleton-captionTitle-loxRi {
	font-size: 16px;
	color: var(--primary-foreground);
}
.Skeleton-showTabletSection-_iqeQ {
	display: none !important;
}
.Skeleton-blockRadioButton-wAh41 {
	margin-top: 0;
	max-width: 320px;
	border: 1px solid var(--primary-border);
	padding: 20px;
}
.Skeleton-jumboSelect-kC4Mx {
	height: 58px !important;
	font-size: 16px !important;
	padding: 15px 47px 20px 20px !important;
	border: 1px solid var(--primary-border) !important;
	border-radius: 4px !important;
}
.Skeleton-jumboSelectPadding-NMc9i {
	padding: 15px 50px 20px 20px !important;
}
.Skeleton-commonBorder-_cR3t {
	border: 1px solid var(--primary-border) !important;
	color: var(--secondary-foreground) !important;
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
	border-radius: 3px !important;
}
.Skeleton-textAignRight-wIp5E {
	text-align: right;
}
.Skeleton-textAlignLeft-T_nsC {
	text-align: left;
}
.Skeleton-textAignCenter-Gx20p {
	text-align: center;
}
.Skeleton-moreFilterTitle-FWq8Q {
	font-size: 18px;
}
.Skeleton-dot-AP4vE {
	color: var(--secondary-foreground);
	font-size: 12px;
	margin-bottom: 0;
}
/*************************** Header Modal Start **********************/
.Skeleton-currencyAndLanguageGrid-YJWfY {
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 30px;
}
.Skeleton-activeItem-fAD64 {
	padding: 15px;
	text-align: center;
	font-size: 16px;
	border-radius: 8px;
	cursor: pointer;
	border: 1px solid var(--primary-border);
}
.Skeleton-activeItem-fAD64:hover,
.Skeleton-activeItem-fAD64:focus,
.Skeleton-activeItem-fAD64:active {
	background-color: var(--common-hover-bg);
	color: var(--primary-foreground);
}
.Skeleton-activeSection-G8m_g:first-child {
	background-color: var(--primary-gray-bg);
	color: var(--primary-foreground);
	border: 1px solid var(--secondary-bg);
	cursor: not-allowed;
}
.Skeleton-commonCloseModalBtn-DJJaZ {
	position: absolute;
	cursor: pointer;
}
.Skeleton-searchIconCommon-sUmdP {
	margin-right: 3px;
	position: relative;
	top: -1px;
}
.Skeleton-loginLabel-kXOzU {
	font-size: 16px;
	margin-bottom: 10px;
	font-weight: 600;
}
@media screen and (max-width: 767px) {

	.Skeleton-dropdownOverflow-DHtdb {
		white-space: break-spaces;
		text-align: left;
	}

	.Skeleton-currencyAndLanguageGrid-YJWfY {
		grid-template-columns: repeat(2, 1fr);
	}
}
@media (max-width:991px) and (min-width:768px) {
	.Skeleton-currencyAndLanguageGrid-YJWfY {
		grid-template-columns: repeat(4, 1fr);
	}
}
/*************************** Header Modal End **********************/
.Skeleton-capitalizeText-Rwp98 {
	text-transform: capitalize;
}
@media screen and (max-width: 767px) {
	.Skeleton-searchFilterPopoverHeader-L0WVT {
		position: fixed;
		top: 0;
		z-index: 7;
		left: 0;
		right: 0;
		width: 100%;
		padding: 24px;
		border-bottom: 1px solid var(--primary-border);
		background-color: var(--modal-bg);
		border-radius: 14px 14px 0 0;
	}
}
@media screen and (max-width: 768px) {
	.Skeleton-searchFilterPopoverFull-l5hKj {
		width: 100%;
		height: 100%;
		top: 0px;
		-webkit-box-shadow: none;
		        box-shadow: none;
		max-height: 100%;
		-webkit-overflow-scrolling: touch;
		border-radius: 14px;
	}

	.Skeleton-searchFilterPopoverContent-YkGCh {
		height: 100%;
		min-height: 100vh;
		-webkit-overflow-scrolling: touch;
	}

	.Skeleton-showTabletSection-_iqeQ {
		display: block !important;
	}

	.Skeleton-hideTabletSection-miY7E {
		display: none !important;
	}
}
@media screen and (max-width: 767px) {
	.Skeleton-searchFilterPopoverFooter-YvpWH {
		position: relative !important;
	}
}
@media screen and (max-width: 350px) {
	.Skeleton-btnFontsize-sh0f4 {
		font-size: 14px !important;
	}
}
@media (max-width: 360px) {
	.Skeleton-searchFilterCloseIcon-Cdz54 {
		font-size: 25px;
	}
}
@media (max-width: 993px) and (min-width: 769px) {
	.Skeleton-responsiveFontsize-wJrB9 {
		font-size: 14px;
	}
}
/*****************Apply Button Alignment Start **********************/
.Skeleton-applyBtnDesktop-mEwtC {
	text-align: right;
}
@media screen and (max-width: 991px) {
	.Skeleton-applyBtnDesktop-mEwtC {
		text-align: center;
	}

	.Skeleton-applyBtnDesktopRight-LipJ1 {
		text-align: right !important;
	}

	.Skeleton-applyBtnDesktopNoPaddingRight-o2uCH {
		padding-right: 0px !important;
	}

}
/*****************Apply Button Alignment Start **********************/
/* Shimmer */
.Skeleton-shimmerWrapper-C23nK {
    position: absolute;
    content: "";
    height: 100%;
    width: 100%;
    background-image: -webkit-gradient(linear, left top, right top, from(#95979e1a), color-stop(20%, #95979e1a), color-stop(40%, #95979e1a), to(#95979e1a));
    background-image: linear-gradient(90deg, #95979e1a 0%, #95979e1a 20%, #95979e1a 40%, #95979e1a 100%);
    background-repeat: no-repeat;
    top: 0;
    left: 0;
    right: 0;
}
.Skeleton-shimmerWrapper-C23nK::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    -webkit-transform: translateX(-100%);
        -ms-transform: translateX(-100%);
            transform: translateX(-100%);
    -webkit-animation: Skeleton-shimmer-spmQW 2s infinite;
            animation: Skeleton-shimmer-spmQW 2s infinite;
    content: '';
    background-image: -webkit-gradient(linear, left top, right top, color-stop(0, rgba(255, 255, 255, 0)), color-stop(20%, rgba(255, 255, 255, 0.2)), color-stop(60%, rgba(255, 255, 255, 0.5)), to(rgba(255, 255, 255, 0)));
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
}
.Skeleton-homeKindGripBorderRadius-I1tcY::before {
    border-radius: 22px 22px 22px 0;
}
@-webkit-keyframes Skeleton-loading-clfLj {
    0% {
        -webkit-transform: translateX(-100%);
                transform: translateX(-100%);
    }

    50% {
        -webkit-transform: translateX(-60%);
                transform: translateX(-60%);
    }

    100% {
        -webkit-transform: translateX(100%);
                transform: translateX(100%);
    }
}
@keyframes Skeleton-loading-clfLj {
    0% {
        -webkit-transform: translateX(-100%);
                transform: translateX(-100%);
    }

    50% {
        -webkit-transform: translateX(-60%);
                transform: translateX(-60%);
    }

    100% {
        -webkit-transform: translateX(100%);
                transform: translateX(100%);
    }
}
@-webkit-keyframes Skeleton-shimmer-spmQW {
    100% {
        -webkit-transform: translateX(100%);
                transform: translateX(100%);
    }
}
@keyframes Skeleton-shimmer-spmQW {
    100% {
        -webkit-transform: translateX(100%);
                transform: translateX(100%);
    }
}
.Skeleton-SkeletonSliderPadding-eb4Bc {
    padding: 0 8px;
}
.Skeleton-skeletonBoxBg-SJXg3 {
    position: relative;
}
.Skeleton-skeletonBoxBg-SJXg3::before {
    background: var(--secondary-gray-bg) !important;
}
.Skeleton-parentBgColor-loNQw {
    background: var(--secondary-gray-bg) !important;
}
.Skeleton-skeletonContent-XBQQ4 {
    border-radius: 15px;
    width: 45%;
    height: 15px;
    overflow: hidden;
    background-color: var(--secondary-gray-bg);
    margin-top: 10px;
    position: relative;
}
.Skeleton-skeletonContent-XBQQ4::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    -webkit-transform: translateX(-100%);
        -ms-transform: translateX(-100%);
            transform: translateX(-100%);
    background-image: -webkit-gradient(linear,
            left top, right top,
            color-stop(0, rgba(var(--secondary-gray-bg), 0)),
            color-stop(20%, rgba(var(--secondary-gray-bg), 0.2)),
            color-stop(60%, rgba(var(--secondary-gray-bg), 0.5)),
            to(rgba(var(--secondary-gray-bg), 0)));
    background-image: linear-gradient(90deg,
            rgba(var(--secondary-gray-bg), 0) 0,
            rgba(var(--secondary-gray-bg), 0.2) 20%,
            rgba(var(--secondary-gray-bg), 0.5) 60%,
            rgba(var(--secondary-gray-bg), 0));
    -webkit-animation: Skeleton-shimmer-spmQW 2s infinite;
            animation: Skeleton-shimmer-spmQW 2s infinite;
    content: '';
}
.Skeleton-popularSkeletonContent-TOX5M {
    width: 120px;
    height: 15px;
    background-color: var(--secondary-gray-bg);
    margin: 25px auto 0 auto;
    overflow: hidden;
    position: relative;
    border-radius: 15px;
}
.Skeleton-popularSkeletonContent-TOX5M::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    -webkit-transform: translateX(-100%);
        -ms-transform: translateX(-100%);
            transform: translateX(-100%);
    background-image: -webkit-gradient(linear,
            left top, right top,
            color-stop(0, rgba(var(--secondary-gray-bg), 0)),
            color-stop(20%, rgba(var(--secondary-gray-bg), 0.2)),
            color-stop(60%, rgba(var(--secondary-gray-bg), 0.5)),
            to(rgba(var(--secondary-gray-bg), 0)));
    background-image: linear-gradient(90deg,
            rgba(var(--secondary-gray-bg), 0) 0,
            rgba(var(--secondary-gray-bg), 0.2) 20%,
            rgba(var(--secondary-gray-bg), 0.5) 60%,
            rgba(var(--secondary-gray-bg), 0));
    -webkit-animation: Skeleton-shimmer-spmQW 2s infinite;
            animation: Skeleton-shimmer-spmQW 2s infinite;
    content: '';
}
.Skeleton-newsBoxOneSkeleton-SMotJ {
    border-radius: 30px;
    width: 500px;
    height: 15px;
    overflow: hidden;
    background-color: var(--secondary-gray-bg);
    position: relative;
    margin-bottom: 40px;
}
.Skeleton-newsBoxOneSkeleton-SMotJ::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    -webkit-transform: translateX(-100%);
        -ms-transform: translateX(-100%);
            transform: translateX(-100%);
    background-image: -webkit-gradient(linear,
            left top, right top,
            color-stop(0, rgba(var(--secondary-gray-bg), 0)),
            color-stop(20%, rgba(var(--secondary-gray-bg), 0.2)),
            color-stop(60%, rgba(var(--secondary-gray-bg), 0.5)),
            to(rgba(var(--secondary-gray-bg), 0)));
    background-image: linear-gradient(90deg,
            rgba(var(--secondary-gray-bg), 0) 0,
            rgba(var(--secondary-gray-bg), 0.2) 20%,
            rgba(var(--secondary-gray-bg), 0.5) 60%,
            rgba(var(--secondary-gray-bg), 0));
    -webkit-animation: Skeleton-shimmer-spmQW 2s infinite;
            animation: Skeleton-shimmer-spmQW 2s infinite;
    content: '';
}
.Skeleton-newsSkeletonPosition-KHf3H {
    position: absolute;
    top: 20%;
    left: 40px;
}
.Skeleton-homeKindOneSkeleton-J8dfH {
    border-radius: 50px;
    width: 200px;
    height: 15px;
    overflow: hidden;
    background-color: var(--secondary-gray-bg);
    position: relative;
    margin-bottom: 20px;
}
.Skeleton-homeKindOneSkeleton-J8dfH::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    -webkit-transform: translateX(-100%);
        -ms-transform: translateX(-100%);
            transform: translateX(-100%);
    background-image: -webkit-gradient(linear,
            left top, right top,
            color-stop(0, rgba(var(--secondary-gray-bg), 0)),
            color-stop(20%, rgba(var(--secondary-gray-bg), 0.2)),
            color-stop(60%, rgba(var(--secondary-gray-bg), 0.5)),
            to(rgba(var(--secondary-gray-bg), 0)));
    background-image: linear-gradient(90deg,
            rgba(var(--secondary-gray-bg), 0) 0,
            rgba(var(--secondary-gray-bg), 0.2) 20%,
            rgba(var(--secondary-gray-bg), 0.5) 60%,
            rgba(var(--secondary-gray-bg), 0));
    -webkit-animation: Skeleton-shimmer-spmQW 2s infinite;
            animation: Skeleton-shimmer-spmQW 2s infinite;
    content: '';
}
.Skeleton-homeKindPositionSkeleton-Lnpuo {
    position: absolute;
    bottom: 20px;
    left: 40px;
}
.Skeleton-popularSkeletonTitle-wIoa2 {
    border-radius: 50px;
    width: 250px;
    height: 41px;
    overflow: hidden;
    background-color: var(--secondary-gray-bg);
    position: relative;
    margin-bottom: 45px;
    margin-left: 24px;
}
.Skeleton-popularSkeletonTwoTitle-RlsHA {
    border-radius: 50px;
    width: 250px;
    height: 41px;
    overflow: hidden;
    background-color: var(--secondary-gray-bg);
    position: relative;
    margin-bottom: 45px;
}
@media (max-width:992px) and (min-width:768px) {
    .Skeleton-homeKindOneSkeleton-J8dfH {
        width: 270px !important;
    }
}
@media (max-width: 767px) {
    .Skeleton-newsBoxOneSkeleton-SMotJ {
        width: 200px !important;
    }

    .Skeleton-homeKindOneSkeleton-J8dfH {
        width: 200px !important;
    }

    .Skeleton-popularSkeletonTitle-wIoa2 {
        margin-top: 45px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/common.css","webpack://./src/components/Skeleton/Skeleton.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzNA;;CAEC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,4BAA4B;CAC5B,WAAW;CACX,qBAAqB;CACrB,kDAAkD;CAClD,6BAA6B;CAC7B,gDAAgD;CAChD,+CAA+C;AAChD;AAEA;CACC,4CAA4C;CAC5C,qBAAqB;AACtB;AAEA;;CAEC,0CAA0C;CAC1C,8CAA8C;CAC9C,+CAA+C;AAChD;AAEA;CACC,gDAAgD;CAChD,oDAAoD;CACpD,+CAA+C;AAChD;AAEA;;CAEC,0CAA0C;CAC1C,mCAAmC;CACnC,sDAAsD;AACvD;AAEA;CACC,gDAAgD;CAChD,yCAAyC;CACzC,sDAAsD;AACvD;AAEA;;;CAGC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kCAAkC;CAClC,gDAAgD;CAChD,oBAAoB;CACpB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,sBAAsB;AACvB;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,gBAAgB;CAChB,mBAAmB;CACnB,qCAAqC;CACrC,0DAAkD;SAAlD,kDAAkD;CAClD,mBAAmB;AACpB;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,SAAS;CACT,WAAW;CACX,UAAU;CACV,eAAe;CACf,wBAAgB;SAAhB,gBAAgB;CAChB,mBAAmB;CACnB,UAAU;CACV,iCAAiC;CACjC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,qBAAqB;CACrB,wBAAqB;IAArB,qBAAqB;AACtB;AAEA;CACC,eAAe;CACf,aAAa;CACb,WAAW;CACX,SAAS;CACT,UAAU;CACV,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qCAAqC;CACrC,OAAO;CACP,QAAQ;CACR,mBAAmB;CACnB,SAAS;CACT,iCAAiC;AAClC;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,cAAc;AACf;AAEA;CACC,cAAc;CACd,WAAW;CACX,sBAAsB;AACvB;AAEA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,mBAAmB;AACpB;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,eAAe;CACf,gCAAgC;AACjC;AAEA;CACC,wBAAwB;AACzB;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,uCAAuC;CACvC,aAAa;AACd;AAEA;CACC,uBAAuB;CACvB,0BAA0B;CAC1B,uCAAuC;CACvC,kDAAkD;CAClD,6BAA6B;AAC9B;AAEA;CACC,uCAAuC;AACxC;AAEA;CACC,kDAAkD;CAClD,6CAA6C;CAC7C,mCAA2B;SAA3B,2BAA2B;CAC3B,6BAA6B;AAC9B;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,gBAAgB;AACjB;AAEA,sEAAsE;AACtE;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;AACV;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,uCAAuC;AACxC;AAGA;;;CAGC,wCAAwC;CACxC,gCAAgC;AACjC;AAEA;CACC,wCAAwC;CACxC,gCAAgC;CAChC,qCAAqC;CACrC,mBAAmB;AACpB;AAEA;CACC,kBAAkB;CAClB,eAAe;AAChB;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,SAAS;AACV;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,gBAAgB;AACjB;AAEA;;CAEC;EACC,yBAAyB;EACzB,gBAAgB;CACjB;;CAEA;EACC,qCAAqC;CACtC;AACD;AAEA;CACC;EACC,qCAAqC;CACtC;AACD;AAEA,oEAAoE;AAEpE;CACC,0BAA0B;AAC3B;AAEA;CACC;EACC,eAAe;EACf,MAAM;EACN,UAAU;EACV,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,8CAA8C;EAC9C,iCAAiC;EACjC,4BAA4B;CAC7B;AACD;AAEA;CACC;EACC,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,wBAAgB;UAAhB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;CACpB;;CAEA;EACC,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;CAClC;;CAEA;EACC,yBAAyB;CAC1B;;CAEA;EACC,wBAAwB;CACzB;AACD;AAEA;CACC;EACC,6BAA6B;CAC9B;AACD;AAEA;CACC;EACC,0BAA0B;CAC3B;AACD;AAEA;CACC;EACC,eAAe;CAChB;AACD;AAEA;CACC;EACC,eAAe;CAChB;AACD;AAEA,qEAAqE;AAErE;CACC,iBAAiB;AAClB;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,4BAA4B;CAC7B;;CAEA;EACC,6BAA6B;CAC9B;;AAED;AAEA,qEAAqE;ACzXrE,YAAY;AACZ;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,uJAAoG;IAApG,oGAAoG;IACpG,4BAA4B;IAC5B,MAAM;IACN,OAAO;IACP,QAAQ;AACZ;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,oCAA4B;QAA5B,gCAA4B;YAA5B,4BAA4B;IAC5B,qDAA8B;YAA9B,6CAA8B;IAC9B,WAAW;IACX,wNAAsJ;IAAtJ,sJAAsJ;AAC1J;AAEA;IACI,+BAA+B;AACnC;AAEA;IACI;QACI,oCAA4B;gBAA5B,4BAA4B;IAChC;;IAEA;QACI,mCAA2B;gBAA3B,2BAA2B;IAC/B;;IAEA;QACI,mCAA2B;gBAA3B,2BAA2B;IAC/B;AACJ;AAZA;IACI;QACI,oCAA4B;gBAA5B,4BAA4B;IAChC;;IAEA;QACI,mCAA2B;gBAA3B,2BAA2B;IAC/B;;IAEA;QACI,mCAA2B;gBAA3B,2BAA2B;IAC/B;AACJ;AAEA;IACI;QACI,mCAA2B;gBAA3B,2BAA2B;IAC/B;AACJ;AAJA;IACI;QACI,mCAA2B;gBAA3B,2BAA2B;IAC/B;AACJ;AAEA;IACI,cAAc;AAClB;AAEA;IACI,kBAAkB;AACtB;AAEA;IACI,+CAA+C;AACnD;AAEA;IACI,+CAA+C;AACnD;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,0CAA0C;IAC1C,gBAAgB;IAChB,kBAAkB;AACtB;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,oCAA4B;QAA5B,gCAA4B;YAA5B,4BAA4B;IAC5B;;;;;kDAI0C;IAJ1C;;;;8CAI0C;IAC1C,qDAA8B;YAA9B,6CAA8B;IAC9B,WAAW;AACf;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,0CAA0C;IAC1C,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,oCAA4B;QAA5B,gCAA4B;YAA5B,4BAA4B;IAC5B;;;;;kDAI0C;IAJ1C;;;;8CAI0C;IAC1C,qDAA8B;YAA9B,6CAA8B;IAC9B,WAAW;AACf;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;AACvB;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,oCAA4B;QAA5B,gCAA4B;YAA5B,4BAA4B;IAC5B;;;;;kDAI0C;IAJ1C;;;;8CAI0C;IAC1C,qDAA8B;YAA9B,6CAA8B;IAC9B,WAAW;AACf;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;AACvB;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,oCAA4B;QAA5B,gCAA4B;YAA5B,4BAA4B;IAC5B;;;;;kDAI0C;IAJ1C;;;;8CAI0C;IAC1C,qDAA8B;YAA9B,6CAA8B;IAC9B,WAAW;AACf;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;AACvB;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import 'utils.css';\n@import 'helpers.css';\n\n.btn,\n.btn:focus {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 6px 12px !important;\n\twidth: auto;\n\toutline: 0 !important;\n\tborder: 1px solid var(--primary-border) !important;\n\tborder-radius: 4px !important;\n\tbackground: var(--background-primary) !important;\n\tcolor: var(--primary-btn-foreground) !important;\n}\n\n.btn:hover {\n\tbackground: var(--primary-border) !important;\n\toutline: 0 !important;\n}\n\n.btnPrimary,\n.btnPrimary:focus {\n\tborder-color: var(--primary-bg) !important;\n\tbackground-color: var(--primary-bg) !important;\n\tcolor: var(--primary-btn-foreground) !important;\n}\n\n.btnPrimary:hover {\n\tborder-color: var(--primary-bg-hover) !important;\n\tbackground-color: var(--primary-bg-hover) !important;\n\tcolor: var(--primary-btn-foreground) !important;\n}\n\n.btnPrimaryBorder,\n.btnPrimaryBorder:focus {\n\tborder-color: var(--primary-bg) !important;\n\tcolor: var(--primary-bg) !important;\n\tbackground-color: var(--background-primary) !important;\n}\n\n.btnPrimaryBorder:hover {\n\tborder-color: var(--primary-bg-hover) !important;\n\tcolor: var(--primary-bg-hover) !important;\n\tbackground-color: var(--background-primary) !important;\n}\n\n.btnLink,\n.btnLink:focus,\n.btnLink:hover {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 0px !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: transparent !important;\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-weight: inherit;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: inherit;\n\tborder: 0px !important;\n}\n\n.searchFilterPopover {\n\tposition: absolute;\n\ttop: 51px;\n\tleft: 0px;\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tdisplay: inline-block;\n\tmax-height: 65vh;\n\tvisibility: visible;\n\tbackground: var(--background-primary);\n\tbox-shadow: 0px 0px 10px var(--primary-box-shadow);\n\tborder-radius: 14px;\n}\n\n.searchFilterPopoverFull {\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tposition: fixed;\n\tleft: 0px;\n\tbottom: 0px;\n\twidth: 66%;\n\theight: initial;\n\tbox-shadow: none;\n\tvisibility: visible;\n\ttop: 148px;\n\tbackground-color: var(--modal-bg);\n\tborder-radius: 4px;\n\tborder-width: initial;\n\tborder-style: none;\n\tborder-color: initial;\n\tborder-image: initial;\n}\n\n.searchFilterPopoverOverlay {\n\tposition: fixed;\n\theight: 100vh;\n\twidth: 100%;\n\ttop: 64px;\n\tz-index: 2;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tbackground: rgba(255, 255, 255, 0.85);\n\tleft: 0;\n\tright: 0;\n\tvisibility: visible;\n\tbottom: 0;\n\t-webkit-overflow-scrolling: touch;\n}\n\n.dateFilterpopVerlayHeight {\n\tmax-height: 100%;\n}\n\n.dateFilterpopVerlayContentHeight {\n\tmin-height: 100% !important;\n}\n\n.searchFilterCloseIcon {\n\tfont-size: 30px;\n\tcolor: var(--secondary-foreground);\n}\n\n.searchFilterPopoverFooter {\n\twidth: 100%;\n\tposition: relative;\n\tline-height: 0;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n\tvertical-align: middle;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\tvertical-align: middle;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n.displayInlineBlock {\n\tdisplay: inline-block;\n\tvertical-align: top;\n\twhite-space: normal;\n}\n\n.fullWidth {\n\twidth: 100% !important;\n}\n\n.captionTitle {\n\tfont-size: 16px;\n\tcolor: var(--primary-foreground);\n}\n\n.showTabletSection {\n\tdisplay: none !important;\n}\n\n.blockRadioButton {\n\tmargin-top: 0;\n\tmax-width: 320px;\n\tborder: 1px solid var(--primary-border);\n\tpadding: 20px;\n}\n\n.jumboSelect {\n\theight: 58px !important;\n\tfont-size: 16px !important;\n\tpadding: 15px 47px 20px 20px !important;\n\tborder: 1px solid var(--primary-border) !important;\n\tborder-radius: 4px !important;\n}\n\n.jumboSelectPadding {\n\tpadding: 15px 50px 20px 20px !important;\n}\n\n.commonBorder {\n\tborder: 1px solid var(--primary-border) !important;\n\tcolor: var(--secondary-foreground) !important;\n\tbox-shadow: none !important;\n\tborder-radius: 3px !important;\n}\n\n.textAignRight {\n\ttext-align: right;\n}\n\n.textAlignLeft {\n\ttext-align: left;\n}\n\n.textAignCenter {\n\ttext-align: center;\n}\n\n.moreFilterTitle {\n\tfont-size: 18px;\n}\n\n.dot {\n\tcolor: var(--secondary-foreground);\n\tfont-size: 12px;\n\tmargin-bottom: 0;\n}\n\n/*************************** Header Modal Start **********************/\n.currencyAndLanguageGrid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(5, 1fr);\n\tgap: 30px;\n}\n\n.activeItem {\n\tpadding: 15px;\n\ttext-align: center;\n\tfont-size: 16px;\n\tborder-radius: 8px;\n\tcursor: pointer;\n\tborder: 1px solid var(--primary-border);\n}\n\n\n.activeItem:hover,\n.activeItem:focus,\n.activeItem:active {\n\tbackground-color: var(--common-hover-bg);\n\tcolor: var(--primary-foreground);\n}\n\n.activeSection:first-child {\n\tbackground-color: var(--primary-gray-bg);\n\tcolor: var(--primary-foreground);\n\tborder: 1px solid var(--secondary-bg);\n\tcursor: not-allowed;\n}\n\n.commonCloseModalBtn {\n\tposition: absolute;\n\tcursor: pointer;\n}\n\n.searchIconCommon {\n\tmargin-right: 3px;\n\tposition: relative;\n\ttop: -1px;\n}\n\n.loginLabel {\n\tfont-size: 16px;\n\tmargin-bottom: 10px;\n\tfont-weight: 600;\n}\n\n@media screen and (max-width: 767px) {\n\n\t.dropdownOverflow {\n\t\twhite-space: break-spaces;\n\t\ttext-align: left;\n\t}\n\n\t.currencyAndLanguageGrid {\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n}\n\n@media (max-width:991px) and (min-width:768px) {\n\t.currencyAndLanguageGrid {\n\t\tgrid-template-columns: repeat(4, 1fr);\n\t}\n}\n\n/*************************** Header Modal End **********************/\n\n.capitalizeText {\n\ttext-transform: capitalize;\n}\n\n@media screen and (max-width: 767px) {\n\t.searchFilterPopoverHeader {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tz-index: 7;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: 100%;\n\t\tpadding: 24px;\n\t\tborder-bottom: 1px solid var(--primary-border);\n\t\tbackground-color: var(--modal-bg);\n\t\tborder-radius: 14px 14px 0 0;\n\t}\n}\n\n@media screen and (max-width: 768px) {\n\t.searchFilterPopoverFull {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\ttop: 0px;\n\t\tbox-shadow: none;\n\t\tmax-height: 100%;\n\t\t-webkit-overflow-scrolling: touch;\n\t\tborder-radius: 14px;\n\t}\n\n\t.searchFilterPopoverContent {\n\t\theight: 100%;\n\t\tmin-height: 100vh;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t.showTabletSection {\n\t\tdisplay: block !important;\n\t}\n\n\t.hideTabletSection {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.searchFilterPopoverFooter {\n\t\tposition: relative !important;\n\t}\n}\n\n@media screen and (max-width: 350px) {\n\t.btnFontsize {\n\t\tfont-size: 14px !important;\n\t}\n}\n\n@media (max-width: 360px) {\n\t.searchFilterCloseIcon {\n\t\tfont-size: 25px;\n\t}\n}\n\n@media (max-width: 993px) and (min-width: 769px) {\n\t.responsiveFontsize {\n\t\tfont-size: 14px;\n\t}\n}\n\n/*****************Apply Button Alignment Start **********************/\n\n.applyBtnDesktop {\n\ttext-align: right;\n}\n\n@media screen and (max-width: 991px) {\n\t.applyBtnDesktop {\n\t\ttext-align: center;\n\t}\n\n\t.applyBtnDesktopRight {\n\t\ttext-align: right !important;\n\t}\n\n\t.applyBtnDesktopNoPaddingRight {\n\t\tpadding-right: 0px !important;\n\t}\n\n}\n\n/*****************Apply Button Alignment Start **********************/","@import '../common.css';\n\n/* Shimmer */\n.shimmerWrapper {\n    position: absolute;\n    content: \"\";\n    height: 100%;\n    width: 100%;\n    background-image: linear-gradient(90deg, #95979e1a 0%, #95979e1a 20%, #95979e1a 40%, #95979e1a 100%);\n    background-repeat: no-repeat;\n    top: 0;\n    left: 0;\n    right: 0;\n}\n\n.shimmerWrapper::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    transform: translateX(-100%);\n    animation: shimmer 2s infinite;\n    content: '';\n    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));\n}\n\n.homeKindGripBorderRadius::before {\n    border-radius: 22px 22px 22px 0;\n}\n\n@keyframes loading {\n    0% {\n        transform: translateX(-100%);\n    }\n\n    50% {\n        transform: translateX(-60%);\n    }\n\n    100% {\n        transform: translateX(100%);\n    }\n}\n\n@keyframes shimmer {\n    100% {\n        transform: translateX(100%);\n    }\n}\n\n.SkeletonSliderPadding {\n    padding: 0 8px;\n}\n\n.skeletonBoxBg {\n    position: relative;\n}\n\n.skeletonBoxBg::before {\n    background: var(--secondary-gray-bg) !important;\n}\n\n.parentBgColor {\n    background: var(--secondary-gray-bg) !important;\n}\n\n.skeletonContent {\n    border-radius: 15px;\n    width: 45%;\n    height: 15px;\n    overflow: hidden;\n    background-color: var(--secondary-gray-bg);\n    margin-top: 10px;\n    position: relative;\n}\n\n.skeletonContent::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    transform: translateX(-100%);\n    background-image: linear-gradient(90deg,\n            rgba(var(--secondary-gray-bg), 0) 0,\n            rgba(var(--secondary-gray-bg), 0.2) 20%,\n            rgba(var(--secondary-gray-bg), 0.5) 60%,\n            rgba(var(--secondary-gray-bg), 0));\n    animation: shimmer 2s infinite;\n    content: '';\n}\n\n.popularSkeletonContent {\n    width: 120px;\n    height: 15px;\n    background-color: var(--secondary-gray-bg);\n    margin: 25px auto 0 auto;\n    overflow: hidden;\n    position: relative;\n    border-radius: 15px;\n}\n\n.popularSkeletonContent::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    transform: translateX(-100%);\n    background-image: linear-gradient(90deg,\n            rgba(var(--secondary-gray-bg), 0) 0,\n            rgba(var(--secondary-gray-bg), 0.2) 20%,\n            rgba(var(--secondary-gray-bg), 0.5) 60%,\n            rgba(var(--secondary-gray-bg), 0));\n    animation: shimmer 2s infinite;\n    content: '';\n}\n\n.newsBoxOneSkeleton {\n    border-radius: 30px;\n    width: 500px;\n    height: 15px;\n    overflow: hidden;\n    background-color: var(--secondary-gray-bg);\n    position: relative;\n    margin-bottom: 40px;\n}\n\n.newsBoxOneSkeleton::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    transform: translateX(-100%);\n    background-image: linear-gradient(90deg,\n            rgba(var(--secondary-gray-bg), 0) 0,\n            rgba(var(--secondary-gray-bg), 0.2) 20%,\n            rgba(var(--secondary-gray-bg), 0.5) 60%,\n            rgba(var(--secondary-gray-bg), 0));\n    animation: shimmer 2s infinite;\n    content: '';\n}\n\n.newsSkeletonPosition {\n    position: absolute;\n    top: 20%;\n    left: 40px;\n}\n\n.homeKindOneSkeleton {\n    border-radius: 50px;\n    width: 200px;\n    height: 15px;\n    overflow: hidden;\n    background-color: var(--secondary-gray-bg);\n    position: relative;\n    margin-bottom: 20px;\n}\n\n.homeKindOneSkeleton::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    transform: translateX(-100%);\n    background-image: linear-gradient(90deg,\n            rgba(var(--secondary-gray-bg), 0) 0,\n            rgba(var(--secondary-gray-bg), 0.2) 20%,\n            rgba(var(--secondary-gray-bg), 0.5) 60%,\n            rgba(var(--secondary-gray-bg), 0));\n    animation: shimmer 2s infinite;\n    content: '';\n}\n\n.homeKindPositionSkeleton {\n    position: absolute;\n    bottom: 20px;\n    left: 40px;\n}\n\n.popularSkeletonTitle {\n    border-radius: 50px;\n    width: 250px;\n    height: 41px;\n    overflow: hidden;\n    background-color: var(--secondary-gray-bg);\n    position: relative;\n    margin-bottom: 45px;\n    margin-left: 24px;\n}\n\n.popularSkeletonTwoTitle {\n    border-radius: 50px;\n    width: 250px;\n    height: 41px;\n    overflow: hidden;\n    background-color: var(--secondary-gray-bg);\n    position: relative;\n    margin-bottom: 45px;\n}\n\n@media (max-width:992px) and (min-width:768px) {\n    .homeKindOneSkeleton {\n        width: 270px !important;\n    }\n}\n\n@media (max-width: 767px) {\n    .newsBoxOneSkeleton {\n        width: 200px !important;\n    }\n\n    .homeKindOneSkeleton {\n        width: 200px !important;\n    }\n\n    .popularSkeletonTitle {\n        margin-top: 45px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `Skeleton-errorMessage-WYcAH`,
	"space1": `Skeleton-space1-sbAdJ`,
	"space2": `Skeleton-space2-uJXc_`,
	"space3": `Skeleton-space3-JiJIJ`,
	"space4": `Skeleton-space4-hhNGm`,
	"space5": `Skeleton-space5-ehTNN`,
	"space6": `Skeleton-space6-Rrr9V`,
	"space7": `Skeleton-space7-gOlQI`,
	"spaceTop8": `Skeleton-spaceTop8-AItb2`,
	"spaceTop1": `Skeleton-spaceTop1-sxFYH`,
	"spaceTop2": `Skeleton-spaceTop2-j8IN7`,
	"spaceTop3": `Skeleton-spaceTop3-OplDJ`,
	"spaceTop4": `Skeleton-spaceTop4-uHYM1`,
	"spaceTop5": `Skeleton-spaceTop5-dMXbw`,
	"spaceTop6": `Skeleton-spaceTop6-XiWZb`,
	"spaceTop7": `Skeleton-spaceTop7-S9Q6C`,
	"noMargin": `Skeleton-noMargin-tJbx2`,
	"padding1": `Skeleton-padding1-fhn99`,
	"padding2": `Skeleton-padding2-VYl0Z`,
	"padding3": `Skeleton-padding3-x0X5E`,
	"padding4": `Skeleton-padding4-vsTIa`,
	"padding5": `Skeleton-padding5-xwieZ`,
	"padding6": `Skeleton-padding6-Igq7R`,
	"padding7": `Skeleton-padding7-ZZrwh`,
	"paddingTop1": `Skeleton-paddingTop1-hg1De`,
	"paddingTop2": `Skeleton-paddingTop2-GJE_N`,
	"paddingTop3": `Skeleton-paddingTop3-edcnt`,
	"paddingTop4": `Skeleton-paddingTop4-MCzvW`,
	"paddingTop5": `Skeleton-paddingTop5-PUG9K`,
	"paddingTop6": `Skeleton-paddingTop6-SNjtE`,
	"paddingTop7": `Skeleton-paddingTop7-Fh4LY`,
	"noPadding": `Skeleton-noPadding-AOyPq`,
	"textBold": `Skeleton-textBold-b3Oe4`,
	"textBolder": `Skeleton-textBolder-Nv1aC`,
	"textNormal": `Skeleton-textNormal-UASON`,
	"spaceBottom20": `Skeleton-spaceBottom20-aQaAY`,
	"spaceBottom10": `Skeleton-spaceBottom10-xI3CA`,
	"marginNone": `Skeleton-marginNone-mE8Vu`,
	"spaceBottom15": `Skeleton-spaceBottom15-jFype`,
	"marginTopNone": `Skeleton-marginTopNone-_UMuY`,
	"spaceTop11": `Skeleton-spaceTop11-IIjPg`,
	"spaceTop21": `Skeleton-spaceTop21-ypqXW`,
	"spaceTop20": `Skeleton-spaceTop20-dmqLW`,
	"spaceTop10": `Skeleton-spaceTop10-EN3O_`,
	"textDarkBlue": `Skeleton-textDarkBlue-mt96o`,
	"textLightBlue": `Skeleton-textLightBlue-chxvm`,
	"textLightSandleGreen": `Skeleton-textLightSandleGreen-qazYU`,
	"textLightBrown": `Skeleton-textLightBrown-CAn48`,
	"textMediumMaroon": `Skeleton-textMediumMaroon-DqCnd`,
	"textBrown": `Skeleton-textBrown-lKP0v`,
	"textMaroon": `Skeleton-textMaroon-bwj4u`,
	"textDarkBrown": `Skeleton-textDarkBrown-K2U0D`,
	"textMediumBrown": `Skeleton-textMediumBrown-2XcXO`,
	"textSkyBlue": `Skeleton-textSkyBlue-OUWXN`,
	"textGray": `Skeleton-textGray-EDlL_`,
	"btn": `Skeleton-btn-y5N8O`,
	"btnPrimary": `Skeleton-btnPrimary-v183z`,
	"btnPrimaryBorder": `Skeleton-btnPrimaryBorder-SjmVP`,
	"btnLink": `Skeleton-btnLink-j1Pg6`,
	"searchFilterPopover": `Skeleton-searchFilterPopover-uqQCA`,
	"searchFilterPopoverFull": `Skeleton-searchFilterPopoverFull-l5hKj`,
	"searchFilterPopoverOverlay": `Skeleton-searchFilterPopoverOverlay-Asnv4`,
	"dateFilterpopVerlayHeight": `Skeleton-dateFilterpopVerlayHeight-AtT_w`,
	"dateFilterpopVerlayContentHeight": `Skeleton-dateFilterpopVerlayContentHeight-FkT2B`,
	"searchFilterCloseIcon": `Skeleton-searchFilterCloseIcon-Cdz54`,
	"searchFilterPopoverFooter": `Skeleton-searchFilterPopoverFooter-YvpWH`,
	"displayTable": `Skeleton-displayTable-XmGG1`,
	"displayTableRow": `Skeleton-displayTableRow-I5G0L`,
	"displayTableCell": `Skeleton-displayTableCell-_y_0K`,
	"displayInlineBlock": `Skeleton-displayInlineBlock-ia3hu`,
	"fullWidth": `Skeleton-fullWidth-gZ9cw`,
	"captionTitle": `Skeleton-captionTitle-loxRi`,
	"showTabletSection": `Skeleton-showTabletSection-_iqeQ`,
	"blockRadioButton": `Skeleton-blockRadioButton-wAh41`,
	"jumboSelect": `Skeleton-jumboSelect-kC4Mx`,
	"jumboSelectPadding": `Skeleton-jumboSelectPadding-NMc9i`,
	"commonBorder": `Skeleton-commonBorder-_cR3t`,
	"textAignRight": `Skeleton-textAignRight-wIp5E`,
	"textAlignLeft": `Skeleton-textAlignLeft-T_nsC`,
	"textAignCenter": `Skeleton-textAignCenter-Gx20p`,
	"moreFilterTitle": `Skeleton-moreFilterTitle-FWq8Q`,
	"dot": `Skeleton-dot-AP4vE`,
	"currencyAndLanguageGrid": `Skeleton-currencyAndLanguageGrid-YJWfY`,
	"activeItem": `Skeleton-activeItem-fAD64`,
	"activeSection": `Skeleton-activeSection-G8m_g`,
	"commonCloseModalBtn": `Skeleton-commonCloseModalBtn-DJJaZ`,
	"searchIconCommon": `Skeleton-searchIconCommon-sUmdP`,
	"loginLabel": `Skeleton-loginLabel-kXOzU`,
	"dropdownOverflow": `Skeleton-dropdownOverflow-DHtdb`,
	"capitalizeText": `Skeleton-capitalizeText-Rwp98`,
	"searchFilterPopoverHeader": `Skeleton-searchFilterPopoverHeader-L0WVT`,
	"searchFilterPopoverContent": `Skeleton-searchFilterPopoverContent-YkGCh`,
	"hideTabletSection": `Skeleton-hideTabletSection-miY7E`,
	"btnFontsize": `Skeleton-btnFontsize-sh0f4`,
	"responsiveFontsize": `Skeleton-responsiveFontsize-wJrB9`,
	"applyBtnDesktop": `Skeleton-applyBtnDesktop-mEwtC`,
	"applyBtnDesktopRight": `Skeleton-applyBtnDesktopRight-LipJ1`,
	"applyBtnDesktopNoPaddingRight": `Skeleton-applyBtnDesktopNoPaddingRight-o2uCH`,
	"shimmerWrapper": `Skeleton-shimmerWrapper-C23nK`,
	"shimmer": `Skeleton-shimmer-spmQW`,
	"homeKindGripBorderRadius": `Skeleton-homeKindGripBorderRadius-I1tcY`,
	"SkeletonSliderPadding": `Skeleton-SkeletonSliderPadding-eb4Bc`,
	"skeletonBoxBg": `Skeleton-skeletonBoxBg-SJXg3`,
	"parentBgColor": `Skeleton-parentBgColor-loNQw`,
	"skeletonContent": `Skeleton-skeletonContent-XBQQ4`,
	"popularSkeletonContent": `Skeleton-popularSkeletonContent-TOX5M`,
	"newsBoxOneSkeleton": `Skeleton-newsBoxOneSkeleton-SMotJ`,
	"newsSkeletonPosition": `Skeleton-newsSkeletonPosition-KHf3H`,
	"homeKindOneSkeleton": `Skeleton-homeKindOneSkeleton-J8dfH`,
	"homeKindPositionSkeleton": `Skeleton-homeKindPositionSkeleton-Lnpuo`,
	"popularSkeletonTitle": `Skeleton-popularSkeletonTitle-wIoa2`,
	"popularSkeletonTwoTitle": `Skeleton-popularSkeletonTwoTitle-RlsHA`,
	"loading": `Skeleton-loading-clfLj`
};
module.exports = ___CSS_LOADER_EXPORT___;
